<template>
  <div class="tw:mb-6 tw:relative">
    <!-- TODO: Remove Easter promo after April 5th, 2026 -->
    <div
      v-if="isEasterPromo"
      class="tw:bg-blue-100 tw:border tw:border-blue-300 tw:px-4 tw:py-5 tw:rounded-xl tw:flex tw:justify-between tw:items-center"
    >
      <div>
        <p class="tw:font-bold tw:text-[20px]">{{ $t('hotel_offers_easter_promo_header') }}</p>
        <p class="tw:text-sm">{{ $t('hotel_offers_packages_banner_subtext') }}</p>
      </div>
      <GhostButton size="medium" class="tw:px-8" @click="emit('openCreateOfferOpen', { offerName: 'easter_package', source: 'banner' })">{{
        $t('hotel_offers_cta')
      }}</GhostButton>
    </div>
    <!-- Original banner -->
    <div
      v-else
      class="tw:bg-blue-100 tw:border tw:border-blue-300 tw:px-4 tw:py-5 tw:rounded-xl tw:flex tw:justify-between tw:items-center"
    >
      <div>
        <p class="tw:font-bold tw:text-[20px]">{{ $t('hotel_offers_packages_banner_headline') }}</p>
        <p class="tw:text-sm">{{ $t('hotel_offers_packages_banner_subtext') }}</p>
        <ul class="tw:text-sm tw:py-3">
          <li class="tw:flex tw:gap-2 tw:items-center">
            <CheckmarkSimple class="tw:text-gray-800 tw:stroke-gray-800 tw:size-6" />
            <span v-html="$t('hotel_offers_packages_benefit_1')"></span>
          </li>
          <li class="tw:flex tw:gap-2 tw:items-center">
            <CheckmarkSimple class="tw:text-gray-800 tw:stroke-gray-800 tw:size-6" />
            <span v-html="$t('hotel_offers_packages_benefit_2')"></span>
          </li>
        </ul>
        <GhostButton size="medium" class="tw:px-8" @click="emit('newOffersClicked')">{{
          $t('hotel_offers_packages_cta')
        }}</GhostButton>
      </div>
      <img :src="newPackagesBanner" alt="Hotel Offers Packages Banner" height="173" width="269" class="tw:h-[155px]" />
    </div>
    <div
      aria-hidden="true"
      class="tw:absolute tw:top-0 tw:bg-red-700 tw:text-white tw:text-xxs tw:font-bold tw:px-[6px] tw:py-[2px] tw:rounded-tl-lg tw:rounded-br-lg"
    >
      {{ $t('hotel_offers_packages_tag_new') }}
    </div>
  </div>
</template>

<script setup>
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import CheckmarkSimple from '@/components/icons/CheckmarkSimple.svg?component'
import newPackagesBanner from '@/assets/img/hotel-offers/hotel-offers-packages-banner.svg'

// TODO: Remove after April 5th, 2026 and revert to the original banner
const isEasterPromo = new Date() < new Date('2026-04-06')

const emit = defineEmits(['newOffersClicked', 'openCreateOfferOpen'])
</script>
